export default __webpack_public_path__ + "static/media/upload.0cddb6f5.svg";